var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-6"},[_c('input-radio-boolean',{staticClass:"flex items-center",attrs:{"label":"Send notifications about this deal?","name":_vm.name,"value":_vm.value,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }